import { Link } from "react-router-dom";
import { creators } from "@/mocks/creators";
import CompareCard from "@/components/feature/CompareCard";

export default function FeaturedSection() {
  const featured = [...creators].sort((a, b) => b.heat - a.heat).slice(0, 3);

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs tracking-[0.24em] text-primary-600">FEATURED</p>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              本期重点对比
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              编辑组按读者查阅量选出的三组，左侧是刚入行时的状态，右侧是最近一次公开露面的样子。
            </p>
          </div>
          <Link
            to="/bang"
            className="inline-flex cursor-pointer items-center gap-2 self-start whitespace-nowrap rounded-md border border-foreground-950 px-5 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
          >
            浏览全部对比
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((creator) => (
            <CompareCard key={creator.slug} creator={creator} summary />
          ))}
        </div>
      </div>
    </section>
  );
}